import React from "react";
import { SectionBadge } from "./Comparison";
import { MousePointerClick, FileCheck2, Banknote, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const STEPS = [
  {
    n: "01",
    time: "60 seconds",
    icon: <MousePointerClick className="h-5 w-5" strokeWidth={2.2} />,
    title: "Tell us what you need",
    body: "Choose an amount between £5,000 and £500M, pick a term up to 120 months, and select one of 17 funding purposes.",
  },
  {
    n: "02",
    time: "3 minutes",
    icon: <FileCheck2 className="h-5 w-5" strokeWidth={2.2} />,
    title: "Quick business snapshot",
    body: "Company name, sector, turnover, trading years. Plain-English click-boxes. We run a soft eligibility check — no footprint on the business file.",
  },
  {
    n: "03",
    time: "24 hours",
    icon: <Banknote className="h-5 w-5" strokeWidth={2.2} />,
    title: "Tailored terms delivered",
    body: "We match you with the right lender on our panel and come back with indicative terms. Sign it and funds are drawn down in as little as 24 hours.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how" className="relative bg-paper-warm py-24 md:py-32">
      <div className="max-w-[1280px] mx-auto px-5 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <SectionBadge>How it works</SectionBadge>
          <h2 className="font-display font-extrabold text-[40px] md:text-[56px] leading-[1.02] tracking-[-0.035em] text-navy mt-5">
            From slider to <span className="text-emerald">signed terms</span><br />
            in under 24 hours.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-5 lg:gap-6 relative">
          {STEPS.map((s) => (
            <div key={s.n} data-testid={`how-step-${s.n}`} className="relative rounded-[20px] bg-white border border-line p-7 md:p-8 hover:shadow-lift transition-shadow duration-300">
              <div className="flex items-start justify-between mb-6">
                <div className="h-12 w-12 rounded-xl bg-navy text-white flex items-center justify-center">
                  {s.icon}
                </div>
                <div className="font-display font-extrabold text-[58px] leading-none tracking-[-0.05em] text-navy/10">{s.n}</div>
              </div>
              <h3 className="font-display font-extrabold text-[22px] md:text-[24px] leading-[1.15] tracking-[-0.02em] text-navy mb-3">
                {s.title}
              </h3>
              <p className="text-[14.5px] leading-[1.6] text-navy/65 font-medium mb-6">{s.body}</p>
              <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-emerald-soft text-emerald-3 font-mono text-[10.5px] uppercase tracking-[0.12em] font-bold">
                <span className="h-1.5 w-1.5 rounded-full bg-emerald" />
                {s.time}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-14">
          <Link to="/apply" data-testid="how-apply-btn" className="btn-shine group inline-flex items-center gap-2 h-14 px-8 rounded-xl bg-emerald text-white font-extrabold text-[15px] hover:bg-emerald-2 transition-colors shadow-emerald">
            Get My Tailored Quote
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" strokeWidth={2.4} />
          </Link>
          <p className="mt-4 text-[13px] text-navy/55 font-semibold">
            No footprint on the business credit file · Indicative terms within the hour
          </p>
        </div>
      </div>
    </section>
  );
}
